/**
 * Copyright © 2022 Delicious AI, LLC
 *
 * @author Stockton Jenkins <stockton.jenkins@deliciousai.com>
 */

import React from 'react'

export interface NotificationState {
  success: string | undefined
  error: string | undefined
  info: string | undefined
  setError: (error?: string) => void
  setSuccess: (success?: string) => void
  setInfo: (info?: string) => void
}

export const NotificationContext = React.createContext<NotificationState>({
  success: undefined,
  error: undefined,
  info: undefined,
  setError: () => null,
  setSuccess: () => null,
  setInfo: () => null,
})
